import { PropsWithChildren } from 'react'
import { Box, Text } from '@machobear/design-system'

interface Props extends PropsWithChildren {
  title: string
}

export const ActionMenu = ({ title, children }: Props) => (
  <Box
    display="flex"
    flexDirection="column"
    paddingTop="gutter"
    paddingRight="gutter"
    paddingBottom="small"
    paddingLeft="gutter"
    gap="xsmall"
  >
    <Text size="small" weight="medium" tone="tertiary">
      {title}
    </Text>
    <Box>{children}</Box>
  </Box>
)
